import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {IGetCategoriesItemDto, IGetCategoriesResponseDTO} from './categories.dto';

@Injectable({
    providedIn: 'root'
})

export class CategoryService {

    constructor (private http:HttpClient) {}


    /**
     * Fetch categories
     * @returns response
     */

    //Same approach as on document type?
    fetchCategories(p: string = '', queryString: string = ''): Observable<IGetCategoriesItemDto[] | IGetCategoriesResponseDTO>{
        return this.http.get<IGetCategoriesItemDto[] | IGetCategoriesResponseDTO>(`categories?p=${p}&q=${queryString}`);
    }


    /**
     * Create category
     * @param formData
     * @returns response
     */
    createCategory(formData){
        return this.http.post('categories', formData);
    }

    /**
     * Update category
     * @param formData
     * @returns response
     */
    updateCategory(formData: { id:number }){
        return this.http.put(`categories/${formData?.id}`, formData);
    }


    /**
     * Remove category
     * @param id
     * @returns response
     */
    removeCategory(id:number){
        return this.http.delete(`categories/${id}`);
    }
}
